
import React, { RefObject } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import LegalSection from './LegalSection';

interface LegalCompanyInfoProps {
  contactRef: RefObject<HTMLHeadingElement>;
  companyDetailsRef: RefObject<HTMLHeadingElement>;
  vatInfoRef: RefObject<HTMLHeadingElement>;
  representativeRef: RefObject<HTMLHeadingElement>;
}

const LegalCompanyInfo: React.FC<LegalCompanyInfoProps> = ({
  contactRef,
  companyDetailsRef,
  vatInfoRef,
  representativeRef
}) => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  
  return (
    <>
      <LegalSection id="contact-info" title={t.contactInfo} titleRef={contactRef}>
        <p className="mb-4 text-gray-300">Future Level</p>
        <p className="mb-4 text-gray-300">Meilipromenade 14<br />6032 Emmen<br />Schweiz</p>
        <p className="mb-4 text-gray-300">
          <strong className="text-purple-200">Email:</strong> <a href="mailto:info@future-level.ch" className="text-purple-400 hover:text-purple-300 underline break-all">info@future-level.ch</a><br />
          <strong className="text-purple-200">Tel:</strong> <a href="tel:+41415391613" className="text-purple-400 hover:text-purple-300 underline">+41 41 539 16 13</a>
        </p>
      </LegalSection>
      
      <LegalSection id="company-details" title={t.companyDetails} titleRef={companyDetailsRef}>
        <p className="mb-4 text-gray-300">
          <strong className="text-purple-200">Firmenname:</strong> Future Level<br />
          <strong className="text-purple-200">Rechtsform:</strong> Einzelunternehmen<br />
          <strong className="text-purple-200">Firmensitz:</strong> Emmen, Schweiz
        </p>
      </LegalSection>
      
      <LegalSection id="vat-info" title={t.vatInfo} titleRef={vatInfoRef}>
        <p className="mb-4 text-gray-300">
          <strong className="text-purple-200">MwSt-Status:</strong> Kleinunternehmen gemäß Art. 10 Abs. 2 lit. a MWSTG
        </p>
      </LegalSection>
      
      <LegalSection id="authorized-representative" title={t.authorizedRepresentative} titleRef={representativeRef}>
        <p className="mb-4 text-gray-300">Pawel Czechowski, Inhaber</p>
      </LegalSection>
    </>
  );
};

export default LegalCompanyInfo;
